export default __webpack_public_path__ + "static/media/shape-oval.8ff41a8e.PNG";